export default __webpack_public_path__ + "static/media/appsIconHC.7220189a.svg";